export default __webpack_public_path__ + "static/885-65fcda3d56097d6d188997f7c2de42d4.gif";